<template>
  <button
    class="btn button-more-filters"
    :class="{ 'icon-only': iconOnly, 'mobile-only': mobileOnly }"
    @click="$emit('click')"
  >
    <i class="icon-filters xs"></i>
    <span v-if="!iconOnly">{{ translate('offDealsMoreFilters') }}</span>
    <div v-show="counter" class="more-filters-counter">
      {{ counter }}
    </div>
  </button>
</template>

<script>
export default {
  name: 'MoreFiltersBtn',
  props: {
    counter: {
      type: Number,
      required: false,
      default: 0
    },
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    mobileOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.button-more-filters {
  position: relative;
  background: color('grey-soft');
  border: 1px solid black;
  border-radius: 100rem;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0.8rem 1.8rem;
  display: flex;
  align-items: center;
  gap: 0px;

  &.icon-only {
    padding: 0;
    padding-left: 9px;
    padding-right: 9px;
    justify-content: center;
    background-color: color('white');
    border: 1px solid color('grey-cool-two');

    i {
      margin-right: 0;
    }
  }

  &.mobile-only {
    display: none;

    min-height: 4rem;
    height: 4rem;
    min-width: 4rem;
    width: 4rem;
    padding: 0;
    justify-content: center;
    align-items: center;

    @media (max-width: media('tablet-l')) {
      display: flex;
    }
  }

  span {
    line-height: 0;
  }

  .more-filters-counter {
    position: absolute;
    top: -6px;
    right: 5px;
    background: color('primary');
    color: color('white');
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0;
    border-radius: 50%;
    height: 16px;
    width: 16px;
    font-size: 1rem;

    @media (max-width: media('tablet-l')) {
      right: -6px;
    }
  }
}
</style>
